import { useEffect } from 'react'
import GitHubIcon from '@material-ui/icons/GitHub'
import LinkedInIcon from '@material-ui/icons/LinkedIn'
import TwitterIcon from '@material-ui/icons/Twitter'
import InstagramIcon from '@material-ui/icons/Instagram'
import { about } from '../../portfolio'

import './About.css'
import Skills from '../Skills/Skills'

function About() {
  const { fname, resume, social } = about
  const title = 'Home'

  useEffect(() => {
    document.title = title
  },[title])

  return (
    <div className='about left'>
      {fname && (
        <div className='name'>
          Hey👋, I&apos;m&nbsp;
          {fname}
        </div>
      )}
      <p className='about__desc'>
        <span className='about_name'>
          &quot;<i>keep it simiple and stupid</i> 💻&quot;
        </span>
        <br />
        <br />
        &emsp;&emsp;
        {/*  {description && description} */}That&apos;s how I work. I am an{' '}
        <span className='bold__link'>Engineer</span> from{' '}
        <a
          className='bold__link link__a'
          href='https://www.google.com/maps/place/Payyanur,+Kerala/@12.1043604,75.1353701,12z/data=!3m1!4b1!4m5!3m4!1s0x3ba46db4bee336ef:0x51175a88285b831!8m2!3d12.0972416!4d75.1933906'
          alt='location'
          target='__blank'
        >
          Payyanur, Kerala🌴
        </a>
        . I have completed my B.Tech in Computer Science from{' '}
        <a
          className='bold__link link__a'
          href='https://gectcr.ac.in/'
          alt='gecthrissur'
          target='__blank'
        >
          Government Engineeing College, Thrissur
        </a>{' '}
        (2018-22). I love building things that make our lifes easier and
        strongly believes that it&apos;s not about being experts at any one
        thing but, you just need to be pretty good at an array of usefull skills
        that, when combined, makes you truly one of a kind
        <br />
        <br />
        &emsp;&emsp; Apart from Tech, I am an occasional{' '}
        <span className='bold__link'>artist🎨</span>, loves listening to{' '}
        <span className='bold__link'>music🎶</span> and a great{' '}
        <span className='bold__link'>Iron Man (I love you 3000🥺) </span> fan. I
        am also interested in <span className='bold__link'>photography</span>{' '}
        and have a great passion for{' '}
        <span className='bold__link'>robotics 🤖</span>.
      </p>

      {/* skills section 
      <Skills /> */}

      {/* <div className='about__footer'>
        <div className='about__contact center'>
          {resume && (
            <a href={resume} target='__blank'>
              <span type='button' className='btn btn--outline'>
                Resume
              </span>
            </a>
          )}
        </div>
         <div className='about__contact center'>
          {social && (
            <>
              {social.github && (
                <a
                  target='__blank'
                  href={social.github}
                  aria-label='github'
                  className='link link--icon'
                >
                  <GitHubIcon />
                </a>
              )}

              {social.linkedin && (
                <a
                  target='__blank'
                  href={social.linkedin}
                  aria-label='linkedin'
                  className='link link--icon'
                >
                  <LinkedInIcon />
                </a>
              )}
              {social.instagram && (
                <a
                  target='__blank'
                  href={social.instagram}
                  aria-label='instagram'
                  className='link link--icon'
                >
                  <InstagramIcon />
                </a>
              )}
              {social.twitter && (
                <a
                  target='__blank'
                  href={social.twitter}
                  aria-label='twitter'
                  className='link link--icon'
                >
                  <TwitterIcon />
                </a>
              )}
            </>
          )}
        </div> 
      </div> */}
    </div>
  )
}

export default About
